export const toggles = {
  authenticated_user: "Any Authenticated User",
  cors_preflight: "CORS Preflight",
  accept: "Public Access",
} as const;
